jQuery('a.repeater-field').on('click', function(e)
{
    // Get an array of each field ID to repeat
    var fields = jQuery(this).data('fields').split('|');

    var repeater = jQuery(this).parent();

    jQuery(fields).each(function(index, field)
    {
        // Update the fields to array fields so they submit correctly
        jQuery('[name="' + field + '"]').attr('name', field + '[]');

        // Track how many times this field has been repeated
        var repeatCount = parseInt( jQuery('#' + field).data('repeats') );

        // Default to 0 repeats if the attribute does not exist
        if( isNaN( repeatCount ) ) repeatCount = 0;
        repeatCount++;

        // Clone the field
        var repeatField = jQuery('#' + field).parent().clone(false);

        // Clear the value
        repeatField.children('#' + field).val('');

        // Update the ID of the field to keep HTML valid
        repeatField.children('#' + field).attr('id', field + '_' + repeatCount);

        // Append the cloned field to the section, before the repeater button
        repeatField.insertBefore(repeater);

        // Update the repeats attribute with the latest count
        jQuery('#' + field).data('repeats', repeatCount);
    });

    e.preventDefault();
});

jQuery(document).ready(function()
{
    if( typeof repeatedFields !== 'undefined' )
    {
        // Get all repeated fields provided by the application form
        var repeated  = JSON.parse(repeatedFields);

        // Loop through all repeater fields
        document.querySelectorAll('.repeater-field').forEach(function(field, index) {

            // Get a jQuery instance of the field
            let $repeater = jQuery(field);

            // Get an array of field IDs for this repeater
            var fields = $repeater.data('fields').split('|');

            // Ensure fields are present
            if( fields.length > 0 && typeof repeated[fields[0]] !== 'undefined' )
            {
                // Get the number of values for the first field (they will all have the same number of values). Skip the first (i=0) as this will already be present on the page
                for( i = 1; i < repeated[fields[0]].length; i++ )
                {
                    // Iterate through each field for each value
                    for( fi = 0; fi < fields.length; fi++ )
                    {
                        // Get the field key and element
                        let key = fields[fi];
                        let $field = jQuery('#' + key);

                        // Change the base name to an array name if needed
                        let baseElement = document.querySelector('[name="' + key + '"]');

                        if( baseElement !== null )
                        {
                            baseElement.setAttribute('name', key + '[]');
                        }

                        // Track how many times this field has been repeated
                        var repeatCount = parseInt( $field.data('repeats') );

                        // Default to 0 repeats if the attribute does not exist
                        if( isNaN( repeatCount ) ) repeatCount = 0;
                        repeatCount = i;

                        // Clone the field
                        var repeatField = $field.parent().clone(false);

                        // Clear the value
                        repeatField.children('#' + key).val(repeated[fields[fi]][i]);

                        // Update the ID of the field to keep HTML valid
                        repeatField.children('#' + key).attr('id', key + '_' + repeatCount);

                        // Append the cloned field to the section, before the repeater button
                        repeatField.insertBefore($repeater.parent());

                        // Update the repeats attribute with the latest count
                        $field.data('repeats', repeatCount);
                    }
                }
            }
        });
    }
});

jQuery('.page-links a').on('click', function(e)
{
    var index = parseInt(jQuery('.page-links').find('a').index(this));

    // Hide the existing selection
    jQuery('.form-page').hide();
    jQuery('.page-links a').removeClass('current');

    // Select the new page
    jQuery(this).addClass('current');
    jQuery('.form-page').eq(index).show();

    if( index === 0 )
    {
        jQuery('.page-navigation .prev a').hide();
    }
    else
    {
        jQuery('.page-navigation .prev a').show();
        jQuery('.page-navigation .prev a').children('span').text('Back to Step ' + index);
    }

    if( index + 1 === jQuery('.form-page').length )
    {
        jQuery('.page-navigation').hide();
    }
    else
    {
        jQuery('.page-navigation').show();
        jQuery('.page-navigation .next a').show();
        jQuery('.page-navigation .next a').children('span').text('Continue to Step ' + (index + 2));
    }

    // Scroll back to the page heading
    jQuery('html, body').animate({ scrollTop: jQuery('.breadcrumbs').offset().top }, 500);

    // Focus the first input on the page
    jQuery('.form-page:visible').find('input,select,textarea').first().focus();

    // Prevent navigation
    e.preventDefault();
});

jQuery('.page-navigation .prev a').on('click', function(e)
{
    var index = jQuery('.form-page').index(jQuery('.form-page:visible'));

    // Hide the existing selection
    jQuery('.form-page').hide();
    jQuery('.page-links a').removeClass('current');

    if( index > 0 )
    {
        jQuery(this).children('span').text('Back to Step ' + (index - 1) );
        jQuery('.form-page').eq(index - 1).show();
        jQuery('.page-links').find('a').eq(index - 1).addClass('current');
    }

    if( index - 1 === 0 )
    {
        jQuery(this).hide();
    }

    jQuery('.page-navigation .next a').show();
    jQuery('.page-navigation .next a').children('span').text('Continue to Step ' + (index + 1));

    // Scroll back to the page heading
    jQuery('html, body').animate({ scrollTop: jQuery('.breadcrumbs').offset().top }, 500);

    // Focus the first input on the page
    jQuery('.form-page:visible').find('input,select,textarea').first().focus();

    // Prevent navigation
    e.preventDefault();
});

jQuery('.page-navigation .next a').on('click', function(e)
{
    var index = jQuery('.form-page').index(jQuery('.form-page:visible'));

    // Hide the existing selection
    jQuery('.form-page').hide();
    jQuery('.page-links a').removeClass('current');

    if( index + 1 < jQuery('.form-page').length )
    {
        jQuery(this).children('span').text('Continue to Step ' + (index + 3) );
        jQuery('.form-page').eq(index + 1).show();
        jQuery('.page-links').find('a').eq(index + 1).addClass('current');
    }

    if( index + 2 >= jQuery('.form-page').length )
    {
        jQuery(this).hide();

        // Hide the page navigation on the last page (as per artwork)
        jQuery('.page-navigation').hide();
    }

    jQuery('.page-navigation .prev a').show();
    jQuery('.page-navigation .prev a').children('span').text('Back to Step ' + (index + 1));

    // Scroll back to the page heading
    jQuery('html, body').animate({ scrollTop: jQuery('.breadcrumbs').offset().top }, 500);

    // Focus the first input on the page
    jQuery('.form-page:visible').find('input,select,textarea').first().focus();

    // Prevent navigation
    e.preventDefault();
});

// Auto-tab for date pickers
jQuery('.date-selector input').on('input', function()
{
    if( this.value.length === jQuery(this).attr('placeholder').length )
    {
        jQuery(this).nextAll('input').first().focus();
    }
});

// Application form "Save for Later" functionality
jQuery('.button.save').on('click', function(e)
{
    // Get a reference to the application form
    var $form = jQuery('#application_form');
    var $button = jQuery(this);

    // Disable the button and indicate that we are waiting
    jQuery(this).addClass('busy');

    // Create a FormData object to send all data to the server
    var formData = new FormData(document.getElementById('application_form'));

    formData.set('action', 'tollers_save_application_form');
    formData.set('nonce', tollers_ajax.nonce);

    // Make the request and mount the resulting data
    jQuery.ajax({
        method: 'POST',
        url: tollers_ajax.ajax_url,
        data: formData,
        processData: false,
        contentType: false,
        cache: false
    })
    .done(function (response)
    {
        // Log the contents of the response for debugging
        console.dir(response);

        // Check whether the form validated
        if( response.success )
        {
            alert('Your progress so far has been saved. Please note that for data protection purposes, your application has been saved to your temporary internet files on your device. To continue with this application at another time, you must log in to this device.  Thank you.');

            // Save a reference to the form
            localStorage.setItem('tollers_application_id', response.data.id);
        }
        else
        {
            alert('There was an error saving your application; please try again shortly. If this persists, please get in touch.');
        }

        // Remove the loading indicator
        $button.removeClass('busy');
    });

    // Prevent navigation
    e.preventDefault();
});

// Application form "Print" functionality
jQuery('.button.print').on('click', function(e)
{
    window.open('/wp-content/themes/tollers-solicitors/modals/print-application.php');

    // Prevent navigation
    e.preventDefault();
});

jQuery('#application_form').on('submit', function(e)
{
    // Prevent standard form submission
    e.preventDefault();

    // Keep a reference to the application form
    var $form = jQuery(this);
    var $errors = $form.find('.form-errors');

    // Animate the removal of existing errors
    $errors.children().slideUp(200, function() {
        this.remove(true);
    });

    // Disable the button and indicate that we are waiting
    $form.find('button[type=submit]').addClass('busy');

    // Create a FormData object to send all data to the server
    var formData = new FormData(this);

    formData.set('action', 'tollers_validate_application_form');
    formData.set('nonce', tollers_ajax.nonce);

    // Make the request and mount the resulting data
    jQuery.ajax({
        method: 'POST',
        url: tollers_ajax.ajax_url,
        data: formData,
        processData: false,
        contentType: false,
        cache: false
    })
    .done(function (response)
    {
        // Log the contents of the response for debugging
        console.dir(response);

        // Check whether the form validated
        if( response.success )
        {
            // Submitted, so we can hide the submit button now
            $form.find('button[type=submit]').removeClass('busy').remove();

            var success = jQuery('<div class="success"></div>');
            success.text('Your training contract application was submitted successfully.');
            success.hide().appendTo($errors).slideDown(200);
            
        }
        else
        {
            // Form did not validate; display the validation errors
            response.data.forEach(function(message) {

                // Create a new container for the message
                var element = jQuery('<div></div>');

                // Add the message text into the element
                element.text(message);

                // Add the element to the errors area with a slide animation
                element.hide().appendTo($errors).slideDown(200);

            });
        }

        // Remove the loading indicator
        $form.find('button[type=submit]').removeClass('busy');
    });

});

// Postcode Lookup (AJAX) - Application Form
jQuery('a.form-postcode-lookup').on('click', function(e)
{
    var houseNo  = jQuery('#' + jQuery(this).data('house-no')).val();
    var postcode = jQuery('#' + jQuery(this).data('postcode')).val();
    var lookup   = this;

    if( typeof houseNo !== 'undefined' && houseNo.trim() !== '' && typeof postcode !== 'undefined' && postcode.trim() !== '' )
    {
        // Make the request and mount the resulting data
        jQuery.ajax({
            method: 'POST',
            url: tollers_ajax.ajax_url,
            data: {
                action: 'tollers_postcode_lookup',
                nonce: tollers_ajax.nonce,
                postcode: postcode
            }
        })
        .done(function (response)
        {
            if(response.success)
            {
                // Load in the address data
                if( typeof( response.data.addressLine1 ) !== 'undefined' )
                {
                    jQuery('#' + jQuery(lookup).data('address-one')).val(houseNo + ' ' + response.data.addressLine1);
                }

                if( typeof( response.data.addressLine2 ) !== 'undefined' )
                {
                    jQuery('#' + jQuery(lookup).data('address-two')).val(response.data.addressLine2);
                }

                if( typeof( response.data.town ) !== 'undefined' )
                {
                    jQuery('#' + jQuery(lookup).data('town')).val(response.data.town);
                }

                // Disable the button to prevent abuse
                jQuery(lookup).attr('data-disabled', 'true');
            }
            else
            {
                if( typeof(response.data.alert) !== 'undefined' ) alert(response.data.alert);
                console.error('There was an error performing the postcode lookup.');
            }
        })
        .fail( function(response)
        {
            console.log(response);
        });
    }
    else
    {
        alert( 'Please enter a house number and postcode.' );
    }

    // Prevent navigation
    e.preventDefault();
});

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

// Field UX

// jQuery('#perm_current, #temp_current').on('input', function(e)
// {
//     if(this.checked)
//     {
//         jQuery(this).parent().prev().find('input').attr('disabled', 'disabled');
//     }
//     else
//     {
//         jQuery(this).parent().prev().find('input').removeAttr('disabled');
//     }
// });






